/* ================================================== */
/* SEARCH > Open search
/* ================================================== */

function openSearch() {

	lastFocusedElement = document.activeElement;

	// Open modal
	$searchContainer.css('display', 'block');
	setTimeout(function() {
		$searchContainer.addClass('search--open');
	}, 100);

	// Add roles
	$searchContainer.attr({
		'tabindex'   : '0',
		'aria-hidden': 'false'
	});

	// Lock, hide and make unfocusable all other elements
	$('body').addClass('overflow-hidden');
	$('body > *:not(' + searchClass + ')').addClass('disable disable--focus no-delay').attr('aria-hidden', 'true');

	// Set focus on input
	if (typeof checkIe() === 'undefined' || checkIe() === false) {

		// Fix iOS' issue which doesn't set focus if setTimeout
		if (checkIos() === true) {
			$inputSearch.focus();
		} else {
			setTimeout(function() {
				$inputSearch.focus();
			}, 100);
		}

	}

}